export default "__VITE_ASSET__FhBNBfa2__"